import { Lightning, Router } from '@lightningjs/sdk'

import Button from '../components/button/button'
import { black, getColor, grey300, grey50, grey920 } from '../constants/colors'
import { UniNeueBold, UniNeueRegular } from '../constants/fonts'
import { Images } from '../constants/paths'
import { LOGIN } from '../constants/routes'
import { getText } from '../utils/dictionary'
import { getAsset } from '../utils/image'

export default class AuthRequired extends Lightning.Component {
  private _currentButton

  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: getColor(grey920),
      collision: true,
      flex: {
        direction: 'column',
      },
      Header: {
        w: (w) => w,
        h: 168,
        rect: true,
        color: getColor(black),
        Logo: {
          x: 73,
          y: 70,
          h: 29,
          w: 246,
          texture: Lightning.Tools.getSvgTexture(getAsset(Images.LOGO_LARGE), 256, 29),
        },
      },
      Container: {
        w: (w) => w,
        h: 912,
        y: 80,
        rect: true,
        color: getColor(grey920),
        flex: {
          direction: 'column',
          alignItems: 'center',
        },
        Title: {
          text: {
            text: getText('authenticationRequired'),
            fontSize: 48,
            lineHeight: 48,
            fontFace: UniNeueBold,
            textColor: getColor(grey50),
          },
          flexItem: {
            marginBottom: 16,
          },
        },
        Info: {
          text: {
            text: '',
            fontSize: 40,
            lineHeight: 40,
            fontFace: UniNeueRegular,
            textColor: getColor(grey300),
          },
          flexItem: {
            marginBottom: 48,
          },
        },
        Buttons: {
          flex: {
            direction: 'column',
          },
          LoginButton: {
            w: 658,
            type: Button,
            label: getText('loginButton'),
            flexItem: {
              marginBottom: 24,
            },
          },
          CancelButton: {
            w: 658,
            type: Button,
            label: getText('cancelButton'),
          },
        },
      },
    }
  }

  get loginButton() {
    return this.tag('LoginButton') as Button
  }

  get cancelButton() {
    return this.tag('CancelButton') as Button
  }

  get info() {
    return this.tag('Info')
  }

  set authReason(v: string) {
    this.info.patch({ text: { text: v } })
  }

  get page() {
    return Router.getActivePage()
  }

  _init() {
    this._currentButton = this.loginButton
    this.loginButton.zIndex = this.zIndex + 1
    this.cancelButton.zIndex = this.zIndex + 1
  }

  _getFocused() {
    return this._currentButton
  }

  _handleKey() {
    // Prevent modal from trying to focus somewhere else
    return true
  }

  _handleDown() {
    if (this._currentButton === this.loginButton) {
      this._currentButton = this.cancelButton
    }
  }

  _handleUp() {
    if (this._currentButton === this.cancelButton) {
      this._currentButton = this.loginButton
    }
  }

  _handleEnter() {
    if (this._currentButton === this.loginButton) {
      Router.navigate(LOGIN, { goBack: true })
    } else {
      this.refocusPage()
    }
  }

  _handleBack(event) {
    event.preventDefault()
    this.refocusPage()
  }

  _handleCursorHide() {
    // Allows capturing the event when the cursor disappears by being idle
    // triggering this modal's _getFocused() method
    this._refocus()
    this._currentButton?._focus()
  }

  refocusPage() {
    this.visible = false
    this._currentButton = this.loginButton
    ;(this.page as any)._setState('Ready')
    Router.focusPage()
  }

  $updateFocusByHover(button) {
    this._currentButton = button
    this._refocus()
  }

  _handleClick(element) {
    if (element instanceof Button) {
      this._handleEnter()
    }
  }
}
